export const urlToNewTabLink = (url, filename) => {
  // generate element <a> to open file on new tab
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", filename)
  link.setAttribute("target", "__blank")
  // document.body.appendChild(link)
  return link
}